(function () {
  const THRESHOLD = 250;

  // ====== Scheduler (debounce + retry) ======
  let scheduled = null;
  function scheduleSync(delay = 80) {
    if (scheduled) clearTimeout(scheduled);
    scheduled = setTimeout(() => syncWithRetry(), delay);
  }

  function parseMoney(text) {
    if (!text) return null;
    const m = text.match(/-?\d[\d\s.]*([.,]\d{2})?/);
    if (!m) return null;

    let s = m[0].replace(/\s/g, '');
    if (s.includes(',') && s.includes('.')) s = s.replace(/\./g, '').replace(',', '.');
    else if (s.includes(',')) s = s.replace(',', '.');

    const n = parseFloat(s);
    return Number.isFinite(n) ? n : null;
  }

  function getDisplayedSubtotal() {
    // ✅ Always read the number BSS decides to display per account (B2B/B2C)
    const totalEl = document.querySelector('[bss-b2b-cart-total-price]');
    if (!totalEl) return null;

    const subtotal = parseMoney(totalEl.textContent);
    return subtotal;
  }

  function getLang() {
    const raw = (document.documentElement.getAttribute('lang') || '').toLowerCase().trim();

    // Normalize (en, en-us -> en)
    const base = raw.split('-')[0];

    // Supported: en, fr, es, it, nl, pt, de
    if (['en', 'fr', 'es', 'it', 'nl', 'pt', 'de'].includes(base)) return base;

    // Fallback: try detect from URL path like /en/, /fr/...
    const path = (location.pathname || '').toLowerCase();
    const m = path.match(/^\/(en|fr|es|it|nl|pt|de)(\/|$)/);
    if (m) return m[1];

    return 'en';
  }

  function formatEUR(amount) {
    const lang = getLang();
    try {
      return new Intl.NumberFormat(lang, {
        style: 'currency',
        currency: 'EUR',
        minimumFractionDigits: 2,
        maximumFractionDigits: 2
      }).format(amount);
    } catch (e) {
      // Fallback EU style
      return '€' + amount.toFixed(2).replace('.', ',');
    }
  }

  function t(key, vars) {
    const lang = getLang();

    const dict = {
      en: {
        eligible: 'You are eligible for the free delivery!',
        away: '{amount} away from free delivery.'
      },
      fr: {
        eligible: 'Vous bénéficiez de la livraison gratuite !',
        away: 'Il vous manque {amount} pour la livraison gratuite.'
      },
      de: {
        eligible: 'Sie sind für kostenlosen Versand berechtigt!',
        away: 'Nur noch {amount} bis zum kostenlosen Versand.'
      },
      es: {
        eligible: '¡Tienes envío gratis!',
        away: 'Te faltan {amount} para el envío gratis.'
      },
      it: {
        eligible: 'Hai diritto alla spedizione gratuita!',
        away: 'Ti mancano {amount} per la spedizione gratuita.'
      },
      nl: {
        eligible: 'Je komt in aanmerking voor gratis verzending!',
        away: 'Nog {amount} tot gratis verzending.'
      },
      pt: {
        eligible: 'Você tem direito ao envio gratuito!',
        away: 'Faltam {amount} para o envio gratuito.'
      }
    };

    const str = (dict[lang] && dict[lang][key]) ? dict[lang][key] : dict.en[key];
    return str.replace(/\{(\w+)\}/g, (_, k) => (vars && vars[k] != null ? vars[k] : ''));
  }

  function syncOnce() {
    const bar = document.querySelector('[data-free-shipping-bar]');
    if (!bar) return false;

    const subtotal = getDisplayedSubtotal();
    if (subtotal === null) return false;

    const remain = Math.max(0, THRESHOLD - subtotal);
    const progress = Math.min(100, Math.max(0, (subtotal / THRESHOLD) * 100));

    const status = bar.querySelector('.free-shipping-bar__status');
    const meter  = bar.querySelector('.free-shipping-bar__progress');

    if (meter) meter.style.setProperty('--width', progress.toFixed(2) + '%');

    if (status) {
      status.textContent =
        remain > 0
          ? t('away', { amount: formatEUR(remain) })
          : t('eligible');
    }

    return true;
  }


  function syncWithRetry() {
    let tries = 0;
    const max = 15;
    const step = 120;

    const tick = () => {
      const ok = syncOnce();
      if (ok) return;

      tries++;
      if (tries >= max) return;
      setTimeout(tick, step);
    };

    tick();
  }

  // ====== 1) Initial ======
  document.addEventListener('DOMContentLoaded', () => {
    scheduleSync(150);
  });

  // ====== 2) Quantity interactions ======
  document.addEventListener('click', (e) => {
    const btn = e.target.closest('button');
    if (!btn) return;

    // Empire usually uses quantity buttons inside a control
    // Catch common +/- naming conventions
    const isQty =
      btn.name === 'plus' ||
      btn.name === 'minus' ||
      btn.dataset?.quantityPlus !== undefined ||
      btn.dataset?.quantityMinus !== undefined ||
      btn.className.toLowerCase().includes('quantity') ||
      btn.getAttribute('aria-label')?.toLowerCase().includes('increase') ||
      btn.getAttribute('aria-label')?.toLowerCase().includes('decrease');

    if (isQty) {
      // Theme/BSS often updates in 2 steps → schedule multiple syncs
      scheduleSync(80);
      scheduleSync(350);
      scheduleSync(800);
    }
  });

  document.addEventListener('change', (e) => {
    const el = e.target;
    if (!el) return;

    if (
      el.matches('input[name="updates[]"]') ||
      el.matches('input.quantity__input') ||
      (el.matches('input[type="number"]') && el.closest('form[action*="/cart"]'))
    ) {
      scheduleSync(120);
      scheduleSync(450);
      scheduleSync(900);
    }
  });

  // ====== 3) Detect cart Ajax updates (fetch patch) ======
  const _fetch = window.fetch;
  if (typeof _fetch === 'function') {
    window.fetch = function (...args) {
      const p = _fetch.apply(this, args);

      try {
        const url = (args && args[0] && args[0].url) ? args[0].url : String(args[0] || '');
        const isCartReq =
          url.includes('/cart/change') ||
          url.includes('/cart/update') ||
          url.includes('/cart/add') ||
          url.includes('/cart.js');

        if (isCartReq) {
          p.then(() => {
            scheduleSync(80);
            scheduleSync(350);
            scheduleSync(800);
          }).catch(() => {});
        }
      } catch (e) {}

      return p;
    };
  }

  // ====== 4) Language modal (Langify popup) ======
  // The popup contains links like /en/, /fr/, /de/, /es/, /it/, /nl/, /pt/
  // We just resync after click (DOM re-render happens right after)
  document.addEventListener('click', (e) => {
    const a = e.target.closest('a');
    if (!a) return;

    const href = a.getAttribute('href') || '';
    const isLangSwitch =
      a.classList.contains('ly-languages-switcher-link') ||
      a.closest('.ly-languages-switcher') ||
      a.closest('.ly-languages') ||
      /^\/(en|fr|de|es|it|nl|pt)(\/|$)/i.test(href);

    if (isLangSwitch) {
      // Language switch often triggers partial rerender then BSS rerender
      scheduleSync(200);
      scheduleSync(700);
      scheduleSync(1400);
    }
  });

  // ====== 5) Safe observer: ONLY watch the Order Summary block ======
  // (not the whole page, avoids freezing)
  (function attachLocalObserver() {
    const container =
      document.querySelector('.cart-sidebar') ||
      document.querySelector('.cart__sidebar') ||
      document.querySelector('.cart__final-total') ||
      document.querySelector('[data-free-shipping-bar]')?.closest('aside') ||
      document.querySelector('[data-free-shipping-bar]')?.parentElement;

    if (!container) return;

    let t = null;
    const obs = new MutationObserver(() => {
      clearTimeout(t);
      t = setTimeout(() => scheduleSync(80), 60);
    });

    obs.observe(container, { childList: true, subtree: true });
  })();

})();
